import { Heading, P, Stack, SvgIcon, Text, useText } from "@sveabank/cc-common";

const LoginFooter = () => {
	const [t, texts] = useText();
	return (
		<>
			<div className="tablet:block hidden w-full bg-black/80 py-6 text-center">
				<Text className="text-text-contrast">
					{t(texts.loginPage.footerLegalInfo, new Date().getFullYear().toString())}
				</Text>
			</div>
			<div className="bg-interactive-secondary tablet:hidden block p-8 text-white">
				<Stack gap={4} align="start">
					<SvgIcon imageSrc="LOGO" height={32} className="text-text-contrast" />
					<Heading.H3 className="text-text-contrast">
						{t(texts.loginPage.footer.visingAddress)}
					</Heading.H3>
					<P className="text-text-contrast">{t(texts.loginPage.footer.address)}</P>
					<Heading.H3 className="text-text-contrast">
						{t(texts.loginPage.footer.customerService)}
					</Heading.H3>
					<P className="text-text-contrast">{t(texts.loginPage.footer.phone)}</P>
					<P className="text-text-contrast">{t(texts.loginPage.footer.openHours)}</P>
					<P className="text-text-contrast">{t(texts.loginPage.footer.privacy)}</P>
					<Text className="text-text-contrast text-sm" italic>
						{t(texts.loginPage.footer.legal, new Date().getFullYear().toString())}
					</Text>
				</Stack>
			</div>
		</>
	);
};

export default LoginFooter;
